import { Routes, Route } from 'react-router';
import { Layout } from '@/features/password';
import { Password } from '@/features/password';

export const Router = () => (
  <Routes>
    <Route path="/*" element={<Layout />}>
      <Route index element={<Password />} />
    </Route>
  </Routes>
);
